import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c8668b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row row-name mb-4" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "discount-name mb-3" }
const _hoisted_4 = { class: "row row-settings mb-5" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "wrapper bg-light rounded p-3" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-4" }
const _hoisted_9 = { class: "d-flex align-items-center fs-3 mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "settings", -1))
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12 col-xxl-4 mb-3 mb-xl-0" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12 col-xl-4 col-xxl-12" }
const _hoisted_15 = {
  key: 0,
  class: "row"
}
const _hoisted_16 = { class: "col-4" }
const _hoisted_17 = ["for"]
const _hoisted_18 = { class: "col-8" }
const _hoisted_19 = ["for"]
const _hoisted_20 = {
  key: 1,
  class: "row"
}
const _hoisted_21 = { class: "col-4" }
const _hoisted_22 = ["for"]
const _hoisted_23 = {
  key: 2,
  class: "row"
}
const _hoisted_24 = { class: "col-4" }
const _hoisted_25 = ["for"]
const _hoisted_26 = { class: "col-4" }
const _hoisted_27 = ["for"]
const _hoisted_28 = {
  key: 3,
  class: "row"
}
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = ["for"]
const _hoisted_31 = {
  key: 4,
  class: "row"
}
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = {
  key: 5,
  class: "row"
}
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = {
  key: 0,
  class: "col-7 col-xl-5 col-xxl-12"
}
const _hoisted_36 = { class: "d-flex flex-row align-items-center" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "close", -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "col-7 col-xl-5 col-xxl-12" }
const _hoisted_40 = {
  key: 1,
  class: "col-7 col-xl-5 col-xxl-12"
}
const _hoisted_41 = { class: "col-12 col-xxl-8" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-8" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-10" }
const _hoisted_46 = { class: "col-2 d-flex flex-column justify-content-end" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_48 = { class: "col-4" }
const _hoisted_49 = { class: "product-card border border-1 rounded mx-auto" }
const _hoisted_50 = { class: "position-relative sma-font-fam" }
const _hoisted_51 = ["src", "alt"]
const _hoisted_52 = { class: "card-body sma-font-fam px-2" }
const _hoisted_53 = ["innerHTML"]
const _hoisted_54 = ["src", "alt"]
const _hoisted_55 = {
  key: 0,
  class: "row row-apply-on mb-4"
}
const _hoisted_56 = { class: "col-12" }
const _hoisted_57 = { class: "wrapper bg-light rounded p-3" }
const _hoisted_58 = { class: "d-flex align-items-center fs-3 mb-3" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "checklist", -1))
const _hoisted_60 = { class: "product-filter-conditions pb-3" }
const _hoisted_61 = { class: "mt-5" }
const _hoisted_62 = { class: "fst-italic m-0" }
const _hoisted_63 = { class: "d-inline-block mt-3 pt-4 border-top border-2 border-light" }
const _hoisted_64 = {
  key: 0,
  class: "row row-settings mt-5"
}
const _hoisted_65 = {
  key: 0,
  class: "col-6 mb-3"
}
const _hoisted_66 = { class: "wrapper bg-light rounded p-3" }
const _hoisted_67 = { class: "d-flex align-items-center fs-3 mb-3" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "sort", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_70 = { class: "col-12 mb-3" }
const _hoisted_71 = { class: "wrapper bg-light rounded p-3" }
const _hoisted_72 = { class: "d-flex align-items-center fs-3 mb-3" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "sort", -1))
const _hoisted_74 = { class: "fs-6 mt-2" }
const _hoisted_75 = { class: "wrapper bg-light rounded p-3" }
const _hoisted_76 = { class: "col-12 mb-3" }
const _hoisted_77 = { class: "text-muted ms-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_MultilingualSwitcher = _resolveComponent("MultilingualSwitcher")!
  const _component_input_number = _resolveComponent("input-number")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_discount_pricelist_section = _resolveComponent("discount-pricelist-section")!
  const _component_input_date = _resolveComponent("input-date")!
  const _component_input_checkbox_boolean = _resolveComponent("input-checkbox-boolean")!
  const _component_input_radio = _resolveComponent("input-radio")!
  const _component_dp_error_message = _resolveComponent("dp-error-message")!
  const _component_RenderedProductLabel = _resolveComponent("RenderedProductLabel")!
  const _component_base_offcanvas_button_open = _resolveComponent("base-offcanvas-button-open")!
  const _component_i18n_input_text_editor = _resolveComponent("i18n-input-text-editor")!
  const _component_DefaultLabel = _resolveComponent("DefaultLabel")!
  const _component_ButtonProductFilterPreview = _resolveComponent("ButtonProductFilterPreview")!
  const _component_ProductFilter = _resolveComponent("ProductFilter")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!
  const _component_staff_discountsteps = _resolveComponent("staff-discountsteps")!
  const _component_base_offcanvas = _resolveComponent("base-offcanvas")!
  const _component_ProductLabel = _resolveComponent("ProductLabel")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CatalogBuildStatus = _resolveComponent("CatalogBuildStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "has-build-status-on-page": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('discount'),
          mode: _ctx.mode,
          "help-text": _ctx.$t('descriptionDiscountsDetail'),
          "back-route": {name: _ctx.returnRoute},
          "show-refresh-button": "",
          onRefresh: _ctx.reloadContent
        }, null, 8, ["title", "mode", "help-text", "back-route", "onRefresh"]),
        _createVNode(_component_GenericFormWrapper, {
          submitData: _ctx.submitData,
          pageUI: _ctx.pageUI,
          buttonClass: "btn-sm"
        }, {
          content: _withCtx(({errors}) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("section", _hoisted_3, [
                  _createVNode(_component_input_text, {
                    modelValue: _ctx.discountScheme.name,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.discountScheme.name) = $event)),
                      _ctx.onFormDataChanged
                    ],
                    modelModifiers: { trim: true },
                    label: _ctx.$t('name'),
                    name: "name",
                    rules: "required|max:100",
                    errors: errors
                  }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h2", _hoisted_9, [
                        _hoisted_10,
                        _createTextVNode(_toDisplayString(_ctx.$t('discountSettings')), 1)
                      ])
                    ]),
                    _createVNode(_component_MultilingualSwitcher, {
                      class: "col-8",
                      errors: errors,
                      "active-language": _ctx.activeLanguage,
                      mb: 2,
                      onUpdateActiveLanguage: _cache[1] || (_cache[1] = (newValue) => _ctx.activeLanguage = newValue)
                    }, null, 8, ["errors", "active-language"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_discount_pricelist_section, {
                            class: "discount-amount mb-3",
                            title: _ctx.$t('discountAmount'),
                            icon: "euro"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.discountScheme.scheme_type_code !== undefined && _ctx.discountScheme.scheme_type_code === _ctx.DiscountSchemeTypeEnum.MANUAL_INPUT)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("label", {
                                        class: "mb-2",
                                        for: _ctx.$t('amount')
                                      }, _toDisplayString(_ctx.$t('amount')), 9, _hoisted_17),
                                      _createVNode(_component_input_number, {
                                        modelValue: _ctx.discountScheme.discount_value,
                                        "onUpdate:modelValue": [
                                          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.discountScheme.discount_value) = $event)),
                                          _ctx.onFormDataChanged
                                        ],
                                        name: _ctx.$t('amount'),
                                        mode: "group-start",
                                        disabled: !_ctx.isDiscountValueApplicable,
                                        min: 0,
                                        errors: errors
                                      }, null, 8, ["modelValue", "name", "disabled", "errors", "onUpdate:modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("label", {
                                        class: "mb-2",
                                        for: _ctx.$t('type')
                                      }, _toDisplayString(_ctx.$t('type')), 9, _hoisted_19),
                                      _createVNode(_component_input_select, {
                                        modelValue: _ctx.discountScheme.type_code,
                                        "onUpdate:modelValue": [
                                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.discountScheme.type_code) = $event)),
                                          _ctx.onFormDataChanged
                                        ],
                                        name: _ctx.$t('type'),
                                        options: _ctx.discountTypeOptions,
                                        rules: "required",
                                        errors: errors
                                      }, null, 8, ["modelValue", "name", "options", "errors", "onUpdate:modelValue"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.discountScheme.scheme_type_code !== undefined && _ctx.discountScheme.scheme_type_code === _ctx.DiscountSchemeTypeEnum.MANUAL_INPUT)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _withDirectives(_createElementVNode("div", _hoisted_21, [
                                      _createElementVNode("label", {
                                        class: "mb-1",
                                        for: _ctx.$t('maximum')
                                      }, _toDisplayString(_ctx.$t('maximum')), 9, _hoisted_22),
                                      _createVNode(_component_input_number, {
                                        modelValue: _ctx.discountScheme.max_allowed_discount_amount,
                                        "onUpdate:modelValue": [
                                          _cache[4] || (_cache[4] = ($event: any) => ((_ctx.discountScheme.max_allowed_discount_amount) = $event)),
                                          _ctx.onFormDataChanged
                                        ],
                                        name: _ctx.$t('maximum'),
                                        mode: "group-start",
                                        "addon-text": "€",
                                        errors: errors
                                      }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"])
                                    ], 512), [
                                      [_vShow, _ctx.discountScheme.type_code === 'PERCENTAGE']
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.isXYDiscount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _createElementVNode("div", _hoisted_24, [
                                      _createElementVNode("label", {
                                        class: "mb-2",
                                        for: _ctx.$t('discountBuyQuantity')
                                      }, _toDisplayString(_ctx.$t('discountBuyQuantity')), 9, _hoisted_25),
                                      _createVNode(_component_input_number, {
                                        modelValue: _ctx.discountScheme.buy_quantity,
                                        "onUpdate:modelValue": [
                                          _cache[5] || (_cache[5] = ($event: any) => ((_ctx.discountScheme.buy_quantity) = $event)),
                                          _ctx.onFormDataChanged
                                        ],
                                        name: _ctx.$t('discountBuyQuantity'),
                                        step: 1,
                                        rules: "required",
                                        mode: "group-start",
                                        min: 0,
                                        errors: errors
                                      }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_26, [
                                      _createElementVNode("label", {
                                        class: "mb-2",
                                        for: _ctx.$t('discountGetQuantity')
                                      }, _toDisplayString(_ctx.$t('discountGetQuantity')), 9, _hoisted_27),
                                      _createVNode(_component_input_number, {
                                        modelValue: _ctx.discountScheme.get_quantity,
                                        "onUpdate:modelValue": [
                                          _cache[6] || (_cache[6] = ($event: any) => ((_ctx.discountScheme.get_quantity) = $event)),
                                          _ctx.onFormDataChanged
                                        ],
                                        name: _ctx.$t('discountGetQuantity'),
                                        step: 1,
                                        rules: "required",
                                        mode: "group-start",
                                        min: 0,
                                        errors: errors
                                      }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.isXYDiscount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("label", {
                                        class: "mb-2",
                                        for: _ctx.$t('scope')
                                      }, _toDisplayString(_ctx.$t('scope')) + " (" + _toDisplayString(_ctx.$t('discountScopeExtraInfo')) + ")", 9, _hoisted_30),
                                      _createVNode(_component_input_select, {
                                        modelValue: _ctx.discountScheme.combination_scope_code,
                                        "onUpdate:modelValue": [
                                          _cache[7] || (_cache[7] = ($event: any) => ((_ctx.discountScheme.combination_scope_code) = $event)),
                                          _ctx.onFormDataChanged
                                        ],
                                        name: _ctx.$t('scope'),
                                        options: _ctx.combinationDiscountOptions,
                                        rules: "required",
                                        errors: errors
                                      }, null, 8, ["modelValue", "name", "options", "errors", "onUpdate:modelValue"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.discountScheme.scheme_type_code !== undefined && _ctx.discountScheme.scheme_type_code === _ctx.DiscountSchemeTypeEnum.ADOPT_FROM_PHARMACY_SOFTWARE)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('discountAmountForPharmacySoftwareSyncInfo')), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.discountScheme.scheme_type_code !== undefined && _ctx.discountScheme.scheme_type_code === _ctx.DiscountSchemeTypeEnum.SHARED_DISCOUNT_SCHEME)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('discountAmountForProvidomSyncInfo')), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["title"])
                        ]),
                        (_ctx.discountScheme.scheme_type_code !== undefined && _ctx.discountScheme.scheme_type_code === _ctx.DiscountSchemeTypeEnum.MANUAL_INPUT)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              _createVNode(_component_discount_pricelist_section, {
                                class: "discount-period mb-3",
                                title: _ctx.$t('period'),
                                icon: "date_range"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_36, [
                                    _createVNode(_component_input_date, {
                                      label: _ctx.$t('begin'),
                                      placeholder: "DD-MM-JJJJ",
                                      name: _ctx.$t('begin'),
                                      modelValue: _ctx.discountScheme.begin_date,
                                      "onUpdate:modelValue": [
                                        _cache[8] || (_cache[8] = ($event: any) => ((_ctx.discountScheme.begin_date) = $event)),
                                        _ctx.onFormDataChanged
                                      ],
                                      rules: "required",
                                      class: "me-3",
                                      errors: errors
                                    }, null, 8, ["label", "name", "modelValue", "errors", "onUpdate:modelValue"]),
                                    _createVNode(_component_input_date, {
                                      label: _ctx.$t('end'),
                                      placeholder: "DD-MM-JJJJ",
                                      name: _ctx.$t('end'),
                                      modelValue: _ctx.discountScheme.end_date,
                                      "onUpdate:modelValue": [
                                        _cache[9] || (_cache[9] = ($event: any) => ((_ctx.discountScheme.end_date) = $event)),
                                        _ctx.onFormDataChanged
                                      ],
                                      rules: "check_date:@begin,@end",
                                      class: "me-3",
                                      errors: errors
                                    }, null, 8, ["label", "name", "modelValue", "errors", "onUpdate:modelValue"]),
                                    (_ctx.discountScheme.end_date)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.removeDiscountSchemePeriod()), ["prevent"])),
                                          class: "btn btn-icon btn-sm mb-3"
                                        }, _hoisted_38))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["title"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_discount_pricelist_section, {
                            class: "discount-client-group mb-3",
                            title: _ctx.$t('clientGroup'),
                            icon: "group"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_input_select, {
                                modelValue: _ctx.discountScheme.client_group_code,
                                "onUpdate:modelValue": [
                                  _cache[11] || (_cache[11] = ($event: any) => ((_ctx.discountScheme.client_group_code) = $event)),
                                  _ctx.onFormDataChanged
                                ],
                                name: _ctx.$t('clientGroup'),
                                options: _ctx.clientGroups,
                                errors: errors
                              }, null, 8, ["modelValue", "name", "options", "errors", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["title"])
                        ]),
                        (_ctx.AbilityContext.isAuthorizedForFeature('ORDER_BASED_DISCOUNTS'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createVNode(_component_discount_pricelist_section, {
                                class: "discount-client-group mb-3",
                                title: _ctx.$t('combination'),
                                icon: "stacks"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_input_checkbox_boolean, {
                                    modelValue: _ctx.discountScheme.is_scheme_cumulative_with_promo_codes,
                                    "onUpdate:modelValue": [
                                      _cache[12] || (_cache[12] = ($event: any) => ((_ctx.discountScheme.is_scheme_cumulative_with_promo_codes) = $event)),
                                      _ctx.onFormDataChanged
                                    ],
                                    label: _ctx.$t('isCumulativeWithShoppingCartDiscounts'),
                                    name: "is_promo_cumulative_with_shopping_cart_discounts",
                                    errors: errors
                                  }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["title"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          (!_ctx.isOrderBasedDiscount)
                            ? (_openBlock(), _createBlock(_component_discount_pricelist_section, {
                                key: 0,
                                class: "discount-show pb-2 mb-3",
                                title: _ctx.$t('discountShowAsFollows'),
                                icon: "visibility"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_input_radio, {
                                    id: "discountDontShow",
                                    label: _ctx.$t('discountDontShow'),
                                    name: "discountShowAsFollows",
                                    errors: errors,
                                    rules: "required",
                                    value: "none",
                                    modelValue: _ctx.selectedDiscountOption,
                                    "onUpdate:modelValue": [
                                      _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedDiscountOption) = $event)),
                                      _ctx.onFormDataChanged
                                    ]
                                  }, null, 8, ["label", "errors", "modelValue", "onUpdate:modelValue"]),
                                  _createVNode(_component_input_radio, {
                                    id: "discountShowPriceOnly",
                                    label: _ctx.$t('discountShowPriceOnly'),
                                    name: "discountShowAsFollows",
                                    errors: errors,
                                    rules: "required",
                                    value: "price",
                                    modelValue: _ctx.selectedDiscountOption,
                                    "onUpdate:modelValue": [
                                      _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedDiscountOption) = $event)),
                                      _ctx.onFormDataChanged
                                    ]
                                  }, null, 8, ["label", "errors", "modelValue", "onUpdate:modelValue"]),
                                  _createVNode(_component_input_radio, {
                                    id: "discountShowPriceAndPercent",
                                    label: _ctx.$t('discountShowPriceAndPercent'),
                                    name: "discountShowAsFollows",
                                    errors: errors,
                                    rules: "required",
                                    value: "pricePercent",
                                    modelValue: _ctx.selectedDiscountOption,
                                    "onUpdate:modelValue": [
                                      _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedDiscountOption) = $event)),
                                      _ctx.onFormDataChanged
                                    ]
                                  }, null, 8, ["label", "errors", "modelValue", "onUpdate:modelValue"]),
                                  _createVNode(_component_dp_error_message, {
                                    class: "invalid-feedback d-block",
                                    name: _ctx.$t('discountShowAsFollows')
                                  }, null, 8, ["name"])
                                ]),
                                _: 2
                              }, 1032, ["title"]))
                            : _createCommentVNode("", true),
                          (_ctx.mode !== _ctx.PageDetailModeEnum.NEW)
                            ? (_openBlock(), _createBlock(_component_discount_pricelist_section, {
                                key: 1,
                                class: "discount-show pb-2 mb-3",
                                title: _ctx.$t('discountLabel'),
                                icon: "label"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("div", _hoisted_45, [
                                      _createVNode(_component_RenderedProductLabel, {
                                        "active-language": _ctx.activeLanguage,
                                        "product-label": _ctx.productLabel,
                                        "color-scheme": _ctx.colorScheme
                                      }, null, 8, ["active-language", "product-label", "color-scheme"])
                                    ]),
                                    _createElementVNode("div", _hoisted_46, [
                                      _createVNode(_component_base_offcanvas_button_open, {
                                        "offcanvas-id": "offcanvas-label",
                                        class: "btn btn-icon btn-primary align-self-end"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_47
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1
                              }, 8, ["title"]))
                            : _createCommentVNode("", true),
                          (_ctx.canShowDiscountMessage)
                            ? (_openBlock(), _createBlock(_component_discount_pricelist_section, {
                                key: 2,
                                class: "discount-message pb-2 mb-3",
                                title: _ctx.$t('discountMessage'),
                                icon: "chat"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_i18n_input_text_editor, {
                                    name: "discount_message",
                                    data: _ctx.discountScheme.discount_message,
                                    "active-language": _ctx.activeLanguage,
                                    "show-language-indicator": "",
                                    errors: errors,
                                    height: 200,
                                    "null-when-empty": "",
                                    "onUpdate:data": _ctx.discountMessageUpdated
                                  }, null, 8, ["data", "active-language", "errors", "onUpdate:data"])
                                ]),
                                _: 2
                              }, 1032, ["title"]))
                            : _createCommentVNode("", true),
                          (_ctx.isShowUnappliedMessage)
                            ? (_openBlock(), _createBlock(_component_discount_pricelist_section, {
                                key: 3,
                                class: "discount-unapplied-message pb-2 mb-3",
                                title: _ctx.$t('unappliedDiscount'),
                                icon: "group"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_i18n_input_text_editor, {
                                    name: "unappliedMessage",
                                    data: _ctx.discountScheme.unapplied_message,
                                    "active-language": _ctx.activeLanguage,
                                    errors: errors,
                                    "show-language-indicator": "",
                                    "null-when-empty": "",
                                    label: _ctx.$t('unappliedMessage'),
                                    mode: "basic",
                                    height: 150,
                                    "wrap-content-tag": '',
                                    "onUpdate:modelValue": _ctx.onFormDataChanged
                                  }, null, 8, ["data", "active-language", "errors", "label", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["title"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createVNode(_component_discount_pricelist_section, { class: "discount-preview pb-3" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("div", _hoisted_50, [
                                  (_ctx.discountLabel && _ctx.productLabel === null)
                                    ? (_openBlock(), _createBlock(_component_DefaultLabel, {
                                        key: 0,
                                        content: _ctx.discountLabel,
                                        "color-scheme": _ctx.colorScheme
                                      }, null, 8, ["content", "color-scheme"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_RenderedProductLabel, {
                                    "active-language": _ctx.activeLanguage,
                                    "product-label": _ctx.productLabel,
                                    "color-scheme": _ctx.colorScheme,
                                    positioned: ""
                                  }, null, 8, ["active-language", "product-label", "color-scheme"]),
                                  _createElementVNode("img", {
                                    src: require('@/assets/images/product-card-discount/product_card.png'),
                                    class: _normalizeClass(['top img-fluid w-100 rounded-top', {'opacity-50': _ctx.selectedDiscountOption === ''}]),
                                    alt: _ctx.$t('discountShowAsFollows')
                                  }, null, 10, _hoisted_51)
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("p", {
                                    class: "name mb-0",
                                    style: _normalizeStyle('color: ' + _ctx.colorScheme.text_color_on_light_color)
                                  }, _toDisplayString(_ctx.$t('productName')), 5),
                                  (!_ctx.isEmptyString(_ctx.discountMessage[_ctx.activeLanguage]))
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        innerHTML: _ctx.discountMessage[_ctx.activeLanguage],
                                        class: "discount-message-preview fst-italic mt-2",
                                        style: _normalizeStyle('color: ' + _ctx.colorScheme.secondary_color)
                                      }, null, 12, _hoisted_53))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("img", {
                                  src: require('@/assets/images/product-card-discount/' + _ctx.selectedDiscountOptionImage),
                                  class: _normalizeClass(['bottom img-fluid w-100 rounded-bottom', {'opacity-50': _ctx.selectedDiscountOption === ''}]),
                                  alt: _ctx.$t('discountShowAsFollows')
                                }, null, 10, _hoisted_54)
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            (_ctx.discountScheme.product_filter !== null && _ctx.discountScheme.product_filter !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("h2", _hoisted_58, [
                        _hoisted_59,
                        _createTextVNode(_toDisplayString(_ctx.$t('applyDiscountOnFollowingProducts')) + " ", 1),
                        (_ctx.discountScheme.product_filter?.code)
                          ? (_openBlock(), _createBlock(_component_ButtonProductFilterPreview, {
                              key: 0,
                              "product-filter-code": _ctx.discountScheme.product_filter?.code,
                              class: "ms-3"
                            }, null, 8, ["product-filter-code"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(_component_ProductFilter, {
                          "is-all-products-filter-allowed": true,
                          modelValue: _ctx.discountScheme.product_filter,
                          "onUpdate:modelValue": [
                            _cache[16] || (_cache[16] = ($event: any) => ((_ctx.discountScheme.product_filter) = $event)),
                            _ctx.onFormDataChanged
                          ],
                          errors: errors
                        }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"]),
                        _createElementVNode("footer", _hoisted_61, [
                          _createVNode(_component_input_checkbox_boolean, {
                            modelValue: _ctx.discountScheme.exclude_prescription_required,
                            "onUpdate:modelValue": [
                              _cache[17] || (_cache[17] = ($event: any) => ((_ctx.discountScheme.exclude_prescription_required) = $event)),
                              _ctx.onFormDataChanged
                            ],
                            label: _ctx.$t('excludeNonPrescriptionDrugs'),
                            name: _ctx.$t('excludeNonPrescriptionDrugs'),
                            errors: errors,
                            class: "mb-2"
                          }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"]),
                          _createElementVNode("p", _hoisted_62, _toDisplayString(`${_ctx.$t('remark')}: ${_ctx.$t('discountsNeverAppliedToPrescriptionDrugs')}.`), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_63, [
              _createVNode(_component_input_select, {
                modelValue: _ctx.discountScheme.status_code,
                "onUpdate:modelValue": [
                  _cache[18] || (_cache[18] = ($event: any) => ((_ctx.discountScheme.status_code) = $event)),
                  _ctx.onFormDataChanged
                ],
                name: "status",
                selectText: _ctx.$t('selectText'),
                options: _ctx.statusOptions,
                rules: "required",
                errors: errors
              }, null, 8, ["modelValue", "selectText", "options", "errors", "onUpdate:modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["submitData", "pageUI"]),
        (_ctx.mode !== _ctx.PageDetailModeEnum.NEW)
          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
              (_ctx.isStaffDiscount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("h2", _hoisted_67, [
                        _hoisted_68,
                        _createTextVNode(_toDisplayString(_ctx.$t('discountStaff')), 1)
                      ]),
                      _createElementVNode("div", null, [
                        (_openBlock(), _createBlock(_component_staff_discountsteps, {
                          readonly: "",
                          "discount-scheme-id": _ctx.id,
                          key: _ctx.staffKey
                        }, null, 8, ["discount-scheme-id"]))
                      ]),
                      _createVNode(_component_base_offcanvas_button_open, {
                        "offcanvas-id": "offcanvas-staff",
                        class: "btn btn-icon btn-primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_69
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.mode !== _ctx.PageDetailModeEnum.NEW && _ctx.isStaffDiscount)
          ? (_openBlock(), _createBlock(_component_base_offcanvas, {
              key: 1,
              title: _ctx.$t('discountStaff'),
              id: "offcanvas-staff",
              label: "offcanvasEditColumn",
              class: "offcanvas-wide"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("h2", _hoisted_72, [
                      _hoisted_73,
                      _createTextVNode(_toDisplayString(_ctx.$t('discountStaff')) + " ", 1),
                      _createElementVNode("span", _hoisted_74, "(" + _toDisplayString(_ctx.$t('immediately_saved')) + ")", 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_staff_discountsteps, {
                        "discount-scheme-id": _ctx.id,
                        onStepsUpdated: _ctx.staffStepsUpdate
                      }, null, 8, ["discount-scheme-id", "onStepsUpdated"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        _createVNode(_component_base_offcanvas, {
          title: _ctx.$t('discountLabel'),
          id: "offcanvas-label",
          label: "offcanvasEditColumn",
          class: "offcanvas-wide"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_75, [
              _createVNode(_component_MultilingualSwitcher, {
                class: "col-12",
                errors: _ctx.languageSwitchErrors,
                "active-language": _ctx.activeLanguage,
                mb: 2,
                onUpdateActiveLanguage: _cache[19] || (_cache[19] = (newValue) => _ctx.activeLanguage = newValue)
              }, null, 8, ["errors", "active-language"]),
              _createVNode(_component_discount_pricelist_section, {
                class: "discount-client-group mb-3",
                title: _ctx.$t('label'),
                icon: "label"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_ProductLabel, {
                        "active-language": _ctx.activeLanguage,
                        "discount-scheme-id": _ctx.id,
                        onProductLabelUpdated: _ctx.reloadLabel
                      }, null, 8, ["active-language", "discount-scheme-id", "onProductLabelUpdated"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["title"])
            ])
          ]),
          _: 1
        }, 8, ["title"]),
        _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.$t('cachingDelayMinutes', [5])), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_CatalogBuildStatus)
  ], 64))
}